type CacheEntry<T> = {
  expiresAt: number
  value: T
}

function isBrowserStorageAvailable(): boolean {
  return typeof window !== 'undefined' && typeof window.sessionStorage !== 'undefined'
}

export async function rememberSession<T>(key: string, ttlMs: number, loader: () => Promise<T>): Promise<T> {
  if (!isBrowserStorageAvailable()) {
    return loader()
  }

  const now = Date.now()

  try {
    const raw = window.sessionStorage.getItem(key)

    if (raw) {
      const cached = JSON.parse(raw) as CacheEntry<T>

      if (cached.expiresAt > now) {
        return cached.value
      }
    }
  } catch {
    window.sessionStorage.removeItem(key)
  }

  const value = await loader()

  try {
    window.sessionStorage.setItem(key, JSON.stringify({
      expiresAt: now + ttlMs,
      value
    }))
  } catch {
    // Storage can be unavailable or full in private browsing; the request result is still valid.
  }

  return value
}

